import React from 'react';
import styles from './Stepper.module.css';

const Stepper = ({
  steps = [],
  activeStepId,
  onStepClick,
  className = '',
  style,
  mt, mb, ml, mr, mx, my, m,
  ...rest
}) => {

  const getIsActive = (step) => {
    return step.id === activeStepId;
  };
  const getIsCompleted = (step, index) => {
    if (step.isCompleted !== undefined) {
      return step.isCompleted;
    }
    const activeIndex = steps.findIndex(s => s.id === activeStepId);
    return activeIndex !== -1 && index < activeIndex;
  };
  const getIsDisabled = (step) => {
    return step.isDisabled || false;
  };

  const wrapperStyle = { ...style };
  const getSpacingValue = (v) => typeof v === 'number' ? `calc(var(--cipher-spacing-unit) * ${v})` : v;
  if (mt !== undefined) wrapperStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) wrapperStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) wrapperStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) wrapperStyle.marginRight = getSpacingValue(mr);
  if (mx !== undefined) { wrapperStyle.marginLeft = getSpacingValue(mx); wrapperStyle.marginRight = getSpacingValue(mx); }
  if (my !== undefined) { wrapperStyle.marginTop = getSpacingValue(my); wrapperStyle.marginBottom = getSpacingValue(my); }
  if (m !== undefined) wrapperStyle.margin = getSpacingValue(m);

  return (
    <nav 
      aria-label="Progress" 
      className={`${styles.stepperContainer} ${className}`}
      style={wrapperStyle}
      {...rest}
    >
      <ol className={styles.stepList}>
        {steps.map((step, index) => {
          const isActive = getIsActive(step);
          const isCompleted = getIsCompleted(step, index);
          const isDisabled = getIsDisabled(step);
          const isClickable = onStepClick && !isDisabled && (isCompleted || isActive); 

          let statusClassName = styles.pending;
          if (isActive) statusClassName = styles.active;
          if (isCompleted && !isActive) statusClassName = styles.completed;
          if (isDisabled) statusClassName = styles.disabled;

          const stepContent = (
            <>
              <span className={styles.stepIndicator}>
                {isCompleted && !isActive ? <span className={styles.iconCompleted}>✓</span> : <span>{index + 1}</span>}
              </span>
              <span className={styles.stepLabel}>{step.label}</span>
            </>
          );

          return (
            <li
              key={step.id || index}
              className={`${styles.stepItem} ${statusClassName}`}
              aria-current={isActive ? 'step' : undefined}
            >
              {isClickable ? (
                <button
                  type="button"
                  className={styles.stepButton}
                  onClick={() => onStepClick(step.id)}
                  disabled={isDisabled}
                  aria-label={`Go to step ${index + 1}: ${step.label}`}
                >
                  {stepContent}
                </button>
              ) : (
                <div className={styles.stepDiv}>
                  {stepContent}
                </div>
              )}
              {index < steps.length - 1 && (
                <div
                  className={`${styles.stepConnector} ${isCompleted || isActive ? styles.connectorActive : ''}`}
                  aria-hidden="true"
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Stepper;